/* eslint-disable */


/**
 * Create styles for `<HelpPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<HelpPage />` styles
 */
const helpPageStyles = ({ theme }) => ({
  container: {
    marginBottom: theme.spacing(1) * 2,
    padding: theme.spacing(1) * 2,
    [theme.breakpoints.down(`xs`)]: {
      left: `50%`,
      marginLeft: `-50vw`,
      marginRight: `-50vw`,
      padding: `${theme.spacing(1) * 2}px ${theme.spacing(1) * 5}px`,
      position: `relative`,
      right: `50%`,
      width: `100vw`,
    },
  },
  foot: {
    marginTop: theme.spacing(1) * 3,
    position: `relative`,
  },
  redirectTitle: {
    color: theme.palette.common.black,
  },
  root: {
    height: `100%`,
    overflowX: `hidden`,
    overflowY: `auto`,
  },
  title: {
    color: theme.palette.common.black,
    marginBottom: theme.spacing(1) * 2,
  },
  titleHeader: {
    marginBottom: theme.spacing(1) * 2,
  },
});

export default helpPageStyles;
